export default __webpack_public_path__ + "static/media/check-circle.bd8bc00a.svg";